import { Grid } from '@material-ui/core';
import { createElement, FC } from 'react';
import { useRecoilValue } from 'recoil';

import ProjectEditingStep from '../../../../entity/ProjectEditingStep';
import { convertStepToOrder } from '../../../../utility/workflowStepConvert';
import { useGetIsPC } from '../../../../utilityHooks/useGetIsPC';
import WorkflowStepper from '../../../component/compound/WorkflowStepper';
import { workflowStepsAtom } from '../atoms/workflowStepsAtom';

type Props = {
  step: ProjectEditingStep;
  updateDraftAndGoToTargetStep: (targetStep: ProjectEditingStep) => void;
};

const MobileOnlyWorkflowStepper: FC<Props> = ({ step, updateDraftAndGoToTargetStep }) => {
  const isPC = useGetIsPC();
  const workflowSteps = useRecoilValue(workflowStepsAtom);

  const handleClickStep = (targetStep: ProjectEditingStep) => {
    const targetStepNumber = convertStepToOrder(targetStep, workflowSteps);
    const currentStepNumber = step ? convertStepToOrder(step, workflowSteps) : 0;
    if (currentStepNumber > targetStepNumber) {
      updateDraftAndGoToTargetStep(targetStep);
    }
  };

  return !isPC ? (
    <Grid item xs={12} sm={12} md={12} lg={3}>
      <WorkflowStepper currentStep={step || 'format'} handleClickStep={handleClickStep} workflowSteps={workflowSteps} />
    </Grid>
  ) : null;
};

export default MobileOnlyWorkflowStepper;
